var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiners(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 40,
    viewBox: "0 0 62 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "diners",
    transform: "translate(-0.756 0.253)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2853",
    "data-name": "Rectangle 2853",
    width: 62,
    height: 40,
    rx: 4,
    transform: "translate(0.756 -0.253)",
    fill: "#0079be"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6573",
    "data-name": "Group 6573",
    transform: "translate(2.764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8227",
    "data-name": "Path 8227",
    d: "M212.434,96.312c0-7.666-6.4-12.964-13.409-12.962h-6.033a12.663,12.663,0,0,0-12.934,12.962,12.862,12.862,0,0,0,12.934,12.739h6.033C206.035,109.084,212.434,103.322,212.434,96.312Z",
    transform: "translate(-167.254 -76.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6572",
    "data-name": "Group 6572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8228",
    "data-name": "Path 8228",
    d: "M207.807,97.43A11.765,11.765,0,1,0,219.546,109.2,11.753,11.753,0,0,0,207.807,97.43Z",
    transform: "translate(-182.031 -89.99)",
    fill: "#0079be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8229",
    "data-name": "Path 8229",
    d: "M252.07,166.3a7.468,7.468,0,0,1,4.776-6.959v13.917A7.465,7.465,0,0,1,252.07,166.3Zm10.1,6.961V159.344a7.458,7.458,0,0,1,0,13.92Z",
    transform: "translate(-233.713 -147.131)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiners);
export default __webpack_public_path__ + "static/media/diners.762627410c5adca0411f664e818b1fa4.svg";
export { ForwardRef as ReactComponent };